export enum SocialRedirectUrlEnum {
  line = '/web/user/auth/line/redirect',
  twitter = '/web/user/auth/twitter/redirect',
  'asp-ostiaries' = '/auth/call',
  email = '/auth/mail-auth',
  google = '/web/user/auth/google/redirect',
  'id-pw' = '/auth/id-pw',
  zalo = '/web/user/auth/zalo/redirect',
}
